const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const getSongId = (value: unknown) => {
  if (!isRecord(value) || !isRecord(value.metadata)) {
    return null;
  }

  return typeof value.metadata.id === "string" ? value.metadata.id : null;
};

export const migrateLegacyPlayerPersistedState = (
  persistedState: unknown,
): Record<string, unknown> | null => {
  if (!isRecord(persistedState)) {
    return null;
  }

  const {
    playlistRecommendationItems: legacyRecommendationItems,
    ...persistedStateWithoutLegacyBuffer
  } = persistedState;
  const playlistQueue = persistedStateWithoutLegacyBuffer.playlistQueue;

  if (
    !Array.isArray(legacyRecommendationItems) ||
    legacyRecommendationItems.length === 0 ||
    !isRecord(playlistQueue) ||
    !Array.isArray(playlistQueue.items)
  ) {
    return persistedStateWithoutLegacyBuffer;
  }

  const existingSongIds = new Set(
    playlistQueue.items
      .map(getSongId)
      .filter((songId): songId is string => songId !== null),
  );
  const recommendationsToAppend = legacyRecommendationItems.filter((item) => {
    const songId = getSongId(item);
    return songId !== null && !existingSongIds.has(songId);
  });

  return {
    ...persistedStateWithoutLegacyBuffer,
    playlistQueue: {
      ...playlistQueue,
      items: [...playlistQueue.items, ...recommendationsToAppend],
    },
  };
};
